import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';

let feedbackActionCallback: (() => void) | null = null;
let feedbackDismissCallback: (() => void) | null = null;

export const getFeedbackActionCallback = () => feedbackActionCallback;
export const getFeedbackDismissCallback = () => feedbackDismissCallback;

export const clearFeedbackActionCallback = () => {
  feedbackActionCallback = null;
};

export const clearFeedbackDismissCallback = () => {
  feedbackDismissCallback = null;
};

export const setFeedbackActionCallback = (callback: (() => void) | null) => {
  feedbackActionCallback = callback;
};

export const setFeedbackDismissCallback = (callback: (() => void) | null) => {
  feedbackDismissCallback = callback;
};

export interface ShowFeedbackPayload {
  message: string;
  success?: boolean;
  variant?: 'success' | 'danger' | 'info';
  actionLabel?: string;
  onAction?: () => void;
  onDismiss?: () => void;
}

export interface FeedbackState {
  message: string | null;
  variant: 'success' | 'danger' | 'info';
  loading: boolean;
  actionLabel: string | null;
}

const initialState: FeedbackState = {
  message: null,
  variant: 'success',
  loading: false,
  actionLabel: null,
};

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    showFeedback: (state, action: PayloadAction<ShowFeedbackPayload>) => {
      state.message = action.payload.message;
      state.variant = action.payload.variant || (action.payload.success ? 'success' : 'danger');
      state.actionLabel = action.payload.actionLabel || null;
      feedbackActionCallback = action.payload.onAction || null;
      feedbackDismissCallback = action.payload.onDismiss || null;
    },
    clearFeedback: (state) => {
      state.message = null;
      state.variant = 'success';
      state.actionLabel = null;
      feedbackActionCallback = null;
      feedbackDismissCallback = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = feedbackSlice;
// Extract and export each action creator by name
export const { showFeedback, clearFeedback, setLoading } = actions;

// Thunk that calls dismiss callback (if any) and clears feedback
export const dismissFeedback = () => (dispatch: Dispatch) => {
  if (feedbackDismissCallback) {
    feedbackDismissCallback();
  }
  dispatch(clearFeedback());
};

// Export the reducer, either as a default or named export
export default reducer;
